// import { apiDomain,expressDomain,frontDomain, environment } from "./configDomain";
import transactionRejected from '@iso/assets/images/traffic-light/transaction-rejected.png';
import transactionApproved from '@iso/assets/images/traffic-light/transaction-approved.png';
import transactionPending from '@iso/assets/images/traffic-light/transaction-pending.png';
import transactionDisabled from '@iso/assets/images/traffic-light/transaction-disabled.png';

import tsboardPending from '@iso/assets/images/traffic-light/board-pending.png';
import tsboardApproved from '@iso/assets/images/traffic-light/board-approved.png';
import tsboardRejected from '@iso/assets/images/traffic-light/board-rejected.png';
import tsboardDisabled from '@iso/assets/images/traffic-light/board-disabled.png';

import cddApproved from '@iso/assets/images/traffic-light/cdd-approved.png';
import cddPending from '@iso/assets/images/traffic-light/cdd-pending.png';
import cddRejected from '@iso/assets/images/traffic-light/cdd-rejected.png';

import transferIn from '@iso/assets/images/traffic-light/transfer-in.webp';
import transferOut from '@iso/assets/images/traffic-light/transfer-out.webp';
const SECRET_KEY = '8asdiu998shd09dasiod90';
const environment = process.env.REACT_APP_ENVIRONMENT;
const domain = process.env.REACT_APP_API_DOMAIN;
const backendDomain = process.env.REACT_APP_EXPRESS_DOMAIN;
// const domain = apiDomain;
// const backendDomain=expressDomain;
const serviceCode = environment == "prod" ? "INCOFINPRD_SHAREDATA" :"mXHvaPWK_DATA_SHARING"
const loginServiceCode = environment == "prod" ? "INCOFINPRD_LOGIN" :"mXHvaPWK_LOGIN"
const clientId = environment == "prod" ? "U7531sZBdV" :"mXHvaPWK"
const itsMeurl = environment == "prod" ?  "https://idp.prd.itsme.services/v2" : "https://idp.e2e.itsme.services/v2"
const frontDomainLoginUrl = environment == "prod" ? 'https://cvsoportal.incofincvso.be/redirect' : 'https://cvso-dev.incofincvso.be/redirect'
const frontDomainOnboardUrl = environment == "prod" ? 'https://cvsoportal.incofincvso.be/investor-onboarding' : 'https://cvso-dev.incofincvso.be/investor-onboarding'


let parPage = 10;
/****** here you can change server url where api runs********/
const userType ={
  updateBackendUser:5
}
const sharePrice={
  partial:130.20,
  full:2604,
}
const dividendStatus={
  10: "Pending" ,
  20: "Dividend Preferences Set" ,
  30: "Progress" , //dividend is not process according to selected choices yet.
  50: "Processed" ,//dividend is processed according to selected choices yet.
  60: "Rejected"
}
const shareType={
  partial:'partial',
  full:'full',
  buy:'Buy',
  sell:'sell'
}
const configMgmnt = {
  enabled: true,
add: domain + 'config/add',
addDividend: domain + 'dividend/add',
updateDividend:domain + 'dividend/update',
dividendlist: domain +'dividend/list',
langlist: domain + 'config/list?config=langConfig',
sharelist: domain +'config/list?config=shareConfig',
investorlist: domain +'config/list?config=investAcceptConfig',
update: domain + 'config/update',
dividendDetail: domain + 'dividend/detail',
downloadDivident:domain+'dividend/doc/download',
downloadTax:domain+'tax/doc/download',
documentList:domain+'dividend/doc/list',
taxAdd:domain+ 'tax/add',
taxList:domain+ 'tax/list',
taxDownload:domain+'cron/taxcalc',
setPreference:domain+'dividend/pref/expire',
taxConfUpdate:domain+'tax/update',
taxfindById:domain+'tax/detail/'
}

const cronApi = {
 testLaunch :domain+ 'cron/divtestlaunch',
 finalLaunch:domain + 'cron/divfinallaunch',
notify:domain + 'cron/sharenotify',
dividendPref:domain + 'dividend/pref/exportExcel',
panFile: domain + 'payment/div/pain'
}

const imageApi={
  upload:domain+'upload'
}

const jwtConfig={
  userLogin:domain+'user/login',
  firstLogin:domain+'user/passSetup',
  verifyOtp:domain+'token/verify',
  sendOtp:domain+'otp/generate',
  portalSingup:domain+'signup/portal',
  legPersonOnboard: domain+'legalperson/onboard'
}
const ssoConfig={
  login:domain+'sso/login'
}
const transactionMgmnt = {
  enabled: true,
  transAdd:domain+'trans/add',
  transUpdate:domain+'trans/update',
  transBulk_Update:domain+'trans/bulk/update',
  translist:domain+'trans/list',
  translistShow:domain+'trans/export/list',
  findById: domain+ 'trans/',
  paymentList: domain+ 'payment/list/export',
  uploadCodaFile:domain+'coda/upload',
  unMatchPayment: domain+'payment/unmatched/list',
  matchPayment: domain+'payment/match',
  payUpdate:domain+'payment/update',
  paymentAdd:domain+'payment/add',
  updatePayment:domain+'payment/detUpdate',
  panDownload: domain+'payment/pain/download',
  deleteTrans: domain+'trans/delete',
  paymentExport: domain+'payment/list/exportExcel',
  transExport: domain+'trans/list/exportExcel'
 }
const logComponent = [
  {key:'invest',value: 'investor'},
  {key:'user',value: 'user'},
  {key:'conf',value: 'configuration'},
  {key:'div',value: "dividend"},
  {key:'divPref',value: "dividendPreference"},
  {key:'noDet',value: '-'},
];
const actionType = [
 { key:'add',value: 'add'},
  {key:'edit',value: 'edit'},
 { key:'login',value: 'login'},
  {key: 'loginSSO', value: 'login-SSO'},
  {key:'loginItsme',value: 'login-itsme'},
  {key:'loginOTP',value: 'login-OTP'},
  {key:'divConfAdd',value: 'dividend config add'},
  {key:'divConfUpdt',value: 'dividend config update'},
  {key:'testLF',value: 'test launch failed'},
  {key:'testLC',value: 'test launch completed'},
  {key:'finalLF',value: 'final launch failed'},
  {key:'finalLC',value: 'final launch completed'},
  {key:'notifShareF',value: 'notify shareholder failed'},
  {key:'notifShareC',value: 'notify shareholder completed'},
  {key:'prefSet',value: 'dividend preferences set'},
  {key:'prefProc',value: 'dividend preferences processed'},
  {key:'onboard',value: 'onboard'},
  {key:'cddVerify',value: 'cdd verified'},
  {key:'cddReject',value: 'cdd rejected'},
  {key:'payCreate',value: 'payment created'},
  {key:'payPaid',value: 'payment paid'},
  {key:'payReject',value: 'payment rejected'},
  {key:'payMap',value: 'payment mapped'},
  {key:'payRef',value: 'payment Refund'},
  {key:'bankAccUpdate',value: 'bank account update'},
  {key:'transApprove',value: 'transaction approved'},
  {key:'transReject',value: 'transaction rejected'},
  {key:'transInit',value: 'transaction initiated'},
  {key:'transComp',value: 'transaction completed'},
  {key:'transMap',value: 'transaction mapped'},
  {key:'transDel',value: 'transaction deleted'},
  {key:'noDet',value: '-'},
  
]
const tableActionType = [
  {key: 'login-itsme', value: 'Login-itsme'},
  {key: 'login-sso', value: 'Login-SSO'},
  {key: 'login-otp', value: 'Login-OTP'},
]
  const  claims={"userinfo":{
    "name":null,
    "given_name":null,
    "family_name":null,
    "birthdate":null,
    "gender":null,
    "locale":null,
    "picture":null,
    "email":null,
    "email_verified":null,
    "phone_number":null,
    "phone_number_verified":null,
    "address":null,
    "http://itsme.services/v2/claim/BENationalNumber":null,
    "http://itsme.services/v2/claim/claim_citizenship":null,
    "http://itsme.services/v2/claim/claim_citizenship_as_iso":null,
    "http://itsme.services/v2/claim/place_of_birth":null,
    "http://itsme.services/v2/claim/BEeidSn":null,
    "http://itsme.services/v2/claim/claim_device":null,
    "http://itsme.services/v2/claim/transaction_info":null,
    "http://itsme.services/v2/claim/verificationDate":null,
    "http://itsme.services/v2/claim/IDDocumentType":null,
    "http://itsme.services/v2/claim/IDIssuingCountry":null,
    "http://itsme.services/v2/claim/issuance_locality":null,
    "http://itsme.services/v2/claim/app":null,
    "http://itsme.services/v2/claim/account":null,
    "http://itsme.services/v2/claim/transaction_ip":null,
    "http://itsme.services/v2/claim/physical_person_photo":null,
    "http://itsme.services/v2/claim/birthdate_as_string":null,
    "http://itsme.services/v2/claim/validityFrom":null,
    "http://itsme.services/v2/claim/validityTo":null,
    "http://itsme.services/v2/claim/IDDocumentSN":null}}
    
  const itsmeConfig ={
  userInfo:domain+'itsme',
    authBording:itsMeurl+'/authorization?client_id='+clientId+'&response_type=code&scope=openid+service:'+serviceCode+'+profile+email+address+phone+eid&state=anystate&redirect_uri='+frontDomainOnboardUrl+'&nonce=anounce&claims='+JSON.stringify(claims),
  //authBording:'https://idp.e2e.itsme.services/v2/authorization?client_id=mXHvaPWK&response_type=code&scope=openid+service:mXHvaPWK_DATA_SHARING+profile+email+address+phone+eid+nationality&state=anystate&redirect_uri='+frontDomain+'investor-onboarding&nonce=anounce&claims='+JSON.stringify(claims),
    // authLogin:  itsMeurl+'/authorization?client_id='+clientId+'&response_type=code&scope=openid+service:'+loginServiceCode+'+profile+email+address+phone+eid&state=anystate&redirect_uri='+frontDomain+'redirect&nonce=anounce&claims='+JSON.stringify(claims)
    authLogin:  itsMeurl+'/authorization?client_id='+clientId+'&response_type=code&scope=openid+service:'+loginServiceCode+'+profile+email+address+phone+eid&state=anystate&redirect_uri='+frontDomainLoginUrl+'&nonce=anounce&claims='+JSON.stringify(claims)
  }
const shareMgmnt={
  getShares:domain+'trans/sell',
  sellShares:domain+'trans/sellShares',
  transferShares:domain+'trans/transferShares'
}
const userMgmnt={
  tickBox: 50,
  ident: 100,
  contact: 200,
  company:250,
  buyShare: 300,
  userConfirm:350,
  transCreated: 400,
  uploadDoc: 450,
  waitForPay: 500,
  paySuccess: 600,
  verifPending: 700,
  cddVerified: 1000,
  userOnboard:domain+'onboardUser',
  userAdd:domain+'user/add',
  userUpdate:domain+'user/update',
  userlist:domain+'user/list',
  investerList:domain+'user/investor/list',
  investorListExport: domain+'user/investor/listExport',
  forgetPassword:domain+'user/forgetPassword',
  findById:domain+'user/',
  cddList:domain+'user/cdd/list',
  cddBulk_Update: domain+'user/bulk/update',
  cddExport: domain+'user/cdd/listExport',
  resetPass:domain+'user/resetPassword',
  setPassClickCount:domain+'user/clickCounter',
  setPassword: domain+'user/setPassword',
  linkActive: domain+'link/active',
  updateAccNo:domain+'user/bank/update',
  companyCddList:domain+'user/cdd/compList',
  compCddExport: domain+'user/cddComp/listExport',
  onboardStatus: domain+'onboard/status'
}
const dividentPref={
  list:domain+'dividend/pref/list',
  update:domain+'dividend/pref/update'
}

const trafficSignal={
  'cddStatus':{
    0:cddPending,
    1:cddApproved,
    2:cddRejected,
    // 3:cddPending,
    // 3:cddDisabled,
    3:cddApproved,
  },
  'cddStatusmsg':{
    0:'CDD Status Pending',
    1:'CDD Status Approved',
    2:'CDD Status Rejected',
    // 3:'CDD Status not available',
    3:'CDD Status to be Reviewed',
  },
  'boardStatus':{
    100:tsboardPending,
    200:tsboardApproved,
    300:tsboardRejected,
    400:tsboardDisabled,
  },
  'boardStatusmsg':{
    100:'Board Status Pending',
    200:'Board Status Approved',
    300:'Board Status Rejected',
    400:'Board Status not available',
  },
  'paymentStatus':{
    0:transactionPending,
    1:transactionApproved,
    2:transactionRejected,
    3:transactionDisabled,
    4:transferIn,
    5:transferOut,
  },
  'paymentStatusmsg':{
    0:'Payment Not Received',
    1:'Payment Status Approved',
    2:'Payment Status Rejected',
    3:'Payment Status not available',
    4:'Payment Not Transferred',
  },
}

 const permissions = {
  'incofinAdmin': {
    'dashboard': ['edit', 'read'],
    'cddDashboard': ['edit', 'read'],
    'userMgmt': ['edit', 'read'],
    'investMgmt': ['edit', 'read'],
    'transMgmt': ['edit', 'read', 'delete'],
    'configMgmt': ['edit', 'read'],
     'commMgmt': ['edit', 'read'],
  },
  'cvsoBoard': {
    'dashboard': ['edit', 'read'],
    'investMgmt': ['read'],
    'transMgmt': ['edit', 'read'],
  },
  'cddUser':{
    'dashboard': ['edit', 'read'],
    'cddDashboard': ['edit', 'read'],
    'userMgmt': ['read'],
    'investMgmt': ['read'],
    'transMgmt': ['read'],
    'configMgmt': ['read'],
     'commMgmt': ['read'],
  },
  'commUser':{
    'dashboard': ['edit', 'read'],
    'cddDashboard': ['read'],
    'userMgmt': ['read'],
    'investMgmt': ['read'],
    'transMgmt': ['read'],
    'configMgmt': ['read'],
     'commMgmt': ['edit', 'read'],
  },
  'basic':{
    'dashboard': ['edit', 'read'],
    'cddDashboard': ['read'],
    'userMgmt': ['read'],
    'investMgmt': ['edit', 'read'],
    'transMgmt': ['read'],
    'configMgmt': ['read'],
     'commMgmt': ['edit', 'read'],
  }

}
const linkInactive = {
 Eng :'Link Inactive!' ,
 Fr:'Lien inactif !',
 Nl:'Link inactief!'
}

const paymentPayStatus={
  "0":'Credit',
  "1":'Debit',
}

const paymentStatusBank={
  "200":"Paid",
  "100":"Unpaid",
  "300":"Rejected"
}
const paymentStatus={
  initiated: 100,
  processed: 200,
  noMatch:300,
  partialMatched: 400,
  verified: 500
}
const tranStatus={
  // 100: 'Initiated',
  0:'In Progress',
  1:'Completed',
  2:'Rejected'
 }
 const finalTansStatus={
  // 100: 'Initiated',
  0:'In Progress',
  // 1:'Approved',
  1:'Completed',
  2:'Rejected'
 }
 const boardApproved={
  // 100:'To be Approved',
  // 200:'Approved',
  100:'In Progress',
  200:'Completed',
  300:'Rejected'
 }
const userStatus={
  0:'Inactive',
  1:'Active'
}
const userRole={
  incofinAdmin:"Incofin Admin",
  cvsoBoard:"CVSO Board",
  client:"Client", 
  basic:'Basic',
  commUser:'Communication',
  cddUser:'CDD'
}
// const usertypes={
//   1:"Identical",
//   2:"LegalRep",
//   4:"Legal Representative",
// }
const log = {
     enabled: true,
  logsList:domain+ 'log/list',
  exportLogs:domain+ 'log/excel/export',
  }
  const auditTrail = {
    enabled: true,
    auditList:domain+ 'audit/list',
 }
 const resetPass={
  enabled: true,
    passUpdate:domain+ 'user/pass/update',
 }
 const monthsName={
  1:'january',
  2:'february',
  3:'march',
  4:'april',
  5:'may',
  6:'june',
  7:'july',
  8:'august', 
  9:'september',
  10:'october',
  11:'november',
  12:'december'
 }
 const investMonths={
  1:'1',
  2:'2',
  3:'3',
  4:'4',
  5:'5',
  6:'6',
  7:'7',
  8:'8',
  9:'9',
  10:'10',
  11:'11',
  12:'12'
 }
 const countryCode = [
  { key: '32', value: 'BE' },
  { key: '33', value: 'FR' },
  { key: '31', value: 'NL' },
  { key: 'other', value: 'Other' },
];
const cddType={
  0:'New ',
  1:'Modified ',
  2:'Aml Limit'
}
const resendOtp={
  errorMssg:"Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.",
  limitErrorMsg:"You've reached the maximum number of attempts. Please try to login again.",
  invalidNumberError: 'Unable to send OTP. The mobile number or country code is invalid. Please contact your Admin'
}
 const pepQuestionsDropdown=[
  {name: 'Employment_income', value: "Employment income"}, 
{name: 'Sale_of_assets', value: "Sale of assets (business, real estate, …)"}, 
{name:'Dividends_or_interests', value: 'Dividends or interests'},
{name:'Inheritance', value: 'Inheritance'},
{name:'Gift', value: 'Gift'},
{name:'Social_allowance', value: 'Social allowance'},
{name:'Other', value: 'Other'},
]
const onboardError = {
  accMailMobNRIN: "We already have an account with this email id, mobile no & NRIN.",
  accMailMob: "We already have an account with this email id & mobile no.",
  accMailNRIN: "We already have an account with this email id & NRIN.",
  accMobNRIN: "We already have an account with this mobile no & NRIN.",
  accMail: "We already have an account with this email id.",
  accMob: "We already have an account with this mobile no.",
  accNRIN: "We already have an account with this NRIN.",
}
const companyType = {
  1:"Corporate entity – listed on regulated stock exchange" ,
  2:"Corporate entity – not listed on regulated stock exchange",
  3:"Entity without legal personality" ,
  4:"Non-profit organization or Foundation" ,
  5:"Institutional investor (incl. DFI's, public administrations and state-owned enterprises)" ,
  6:"Personal asset holding vehicle, Trust or Fiduciary" ,
}
const companyTempType = {
  "Corporate entity – listed on regulated stock exchange" :1,
  "Corporate entity – not listed on regulated stock exchange": 2,
  "Entity without legal personality" :3,
  "Non-profit organization or Foundation":4 ,
  "Institutional investor (incl. DFI's, public administrations and state-owned enterprises)" :5,
  "Personal asset holding vehicle, Trust or Fiduciary" :6,
}
const errorMsg = {
  userError : "User name does not exists",
  invalidNumberError:'Unable to send OTP, Please check mobile number or country code and try again'
}
const commPref = {
  digital: "Digital Only",
  digital_paper: "Digital + Paper",
  no_comm : "No Communication"
}
const reference = {
  "Family" : "Family",
  "Friends": "Friends",
  "Info_on_another_website":"Info on another website",
  "Magazine": "Magazine",
  "Newspaper": "Newspaper",
  "Search_engine": "Search engine",
}
const gender = {
  m: "Male",
  f: "Female",
  o: "Non-Binary",
  pnts: "I Prefer not to Answer"
}
const language = {
  en: "EN",
  fr: "FR",
  nl: "NL",
}
const forgetPasswordErr = {
  incorrectUN: "Incorrect User Name",
  incorrectDOB: "Incorrect Date of Birth",
  notVarifyDOB: "We couldn’t verify your date of birth. Please contact your Admin for assistance.",
  incorrectDOBFR :"Date de naissance incorrecte",
  incorrectUNFR :"Numéro d'actionnaire incorrect",
  notVarifyDOBFR:"Nous n'avons pas pu vérifier votre date de naissance. Veuillez contacter votre administrateur pour obtenir de l'aide.",
  notVarifyDOBNL:"We konden uw geboortedatum niet verifiëren. Neem contact op met uw beheerder voor assistentie."
}
const EN_translation = {
  invalidNumErr: "Unable to send OTP. The mobile number or country code is invalid. Please contact your Admin",
  errData: "Data incorrect",
  invData: "Invalid data",
  buyShare_buyWarning: "Please by atleast one share",
  edit_mandQues: "Please give Answer to the Mandatory Questions",
  chkPhnNoErr: "Unable to send OTP, Please check mobile number or country code and try again",
  authFail: "Authentication Failed! Incorrect password",
  userNotExists: "User name does not exists",
  accExists: "This account already exists. Contact info@incofincvso for further information.",
  accFreeze: "Heads Up..! This account is freezed. Kindly contact the admins for further assistance.",
}
const NL_translation = {
  invalidNumErr: "Impossible d'envoyer l'OTP. Le numéro de mobile ou le code du pays est invalide. Veuillez contacter votre administrateur",
  errData: "Gegevens onjuist",
  invData: "Ongeldige gegevens",
  buyShare_buyWarning: "Koop ten minste één aandeel",
  edit_mandQues: "Geef antwoord op de verplichte vragen",
  chkPhnNoErr: "Kan OTP niet verzenden, controleer het mobiele nummer of de landcode en probeer het opnieuw",
  authFail: "Authenticatie mislukt! Onjuist wachtwoord",
  userNotExists: "Gebruikersnaam bestaat niet",
  accExists: "Dit account bestaat reeds. Neem contact op met info@incofincvso voor meer informatie.",
  accFreeze: "Let op..! Deze rekening is geblokkeerd. Neem voor verdere hulp contact op met de beheerders",
}
const FR_translation = {
  invalidNumErr: "Kan OTP niet verzenden. Het mobiele nummer of de landcode is ongeldig. Neem contact op met uw beheerder",
  errData: "Données incorrectes",
  invData: "Données non valides",
  buyShare_buyWarning: "Veuillez acheter au moins une action",
  edit_mandQues: "Veuillez répondre aux questions obligatoires",
  chkPhnNoErr: "Impossible d'envoyer l'OTP, veuillez vérifier le numéro de mobile ou le code du pays et réessayer",
  authFail: "Authentification échouée ! Mot de passe incorrect",
  userNotExists: "Le nom d'utilisateur n'existe pas",
  accExists: "Ce compte existe déjà. Contactez info@incofincvso pour plus d’informations",
  accFreeze: "Attention ..! Ce compte est gelé. Veuillez contacter les administrateurs pour obtenir de l'aide supplémentaire",
}
export {
  configMgmnt,
  backendDomain,
  transactionMgmnt,
  parPage,
  userMgmnt,
  sharePrice,
  shareType,
  paymentStatus,
  imageApi,
  log,
  jwtConfig,
  userStatus,
  userRole,
  monthsName,
 investMonths,
  tranStatus,
  boardApproved,
  ssoConfig,
  permissions,
  countryCode,
  cddType,
  trafficSignal,
  paymentPayStatus,
  paymentStatusBank,
  shareMgmnt,
  finalTansStatus,
  resendOtp,
  userType,
  itsmeConfig,
  cronApi,
  dividentPref,
  dividendStatus,
  auditTrail,
  actionType,
  logComponent,
  pepQuestionsDropdown,
  resetPass,
  onboardError,
  errorMsg,
  companyType,
  companyTempType,
  commPref,
  gender,
  language,
  reference,
  tableActionType,
  linkInactive,
  forgetPasswordErr,
  EN_translation,
  FR_translation,
  NL_translation,
  SECRET_KEY
  // usertypes
};
